import React, { ReactNode } from 'react'

interface ILabelText {
    labelText: ReactNode
}
const Label: React.FC<ILabelText> = ({ labelText }: ILabelText) => {
    return (
        <div className='flex items-center gap-1'>
            <span className='text-base font-bold text-gray-300'>{labelText}</span>
        </div>
    )
}

export default Label
